import axios from '../config/axios';
import { getApiUrl } from '../config/environment';
import type { PhysiotherapyAssessmentRecord } from '../types/physiotherapyAssessment';

export async function listPhysiotherapyAssessments(params: Record<string, unknown> = {}) {
  const res = await axios.get(getApiUrl('/clinic/physiotherapy-assessments'), { params });
  return res.data;
}

export async function getPhysiotherapyAssessment(id: string): Promise<PhysiotherapyAssessmentRecord> {
  const res = await axios.get(getApiUrl(`/clinic/physiotherapy-assessments/${id}`));
  return res.data?.data;
}

export async function createPhysiotherapyAssessment(payload: Record<string, unknown>) {
  const res = await axios.post(getApiUrl('/clinic/physiotherapy-assessments'), payload);
  return res.data?.data as PhysiotherapyAssessmentRecord;
}

export async function updatePhysiotherapyAssessment(id: string, payload: Record<string, unknown>) {
  const res = await axios.put(getApiUrl(`/clinic/physiotherapy-assessments/${id}`), payload);
  return res.data?.data as PhysiotherapyAssessmentRecord;
}

export async function deletePhysiotherapyAssessment(id: string) {
  await axios.delete(getApiUrl(`/clinic/physiotherapy-assessments/${id}`));
}

export async function getPhysiotherapyAssessmentPrintData(id: string) {
  const res = await axios.get(getApiUrl(`/clinic/physiotherapy-assessments/${id}/print`));
  return res.data?.data;
}
